module.exports = __webpack_public_path__ + "static/media/attack-of-the-clones-thumb.3e16b31b.png";